import React, { useEffect, useRef, useState } from 'react';
import { embedDashboard } from '@superset-ui/embedded-sdk';

const View = ({ data }) => {
  const dashboardRef = useRef(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const dashHeight = data.height ? `${data.height}px` : '800px';

  useEffect(() => {
    if (!data.dashboard_id || !dashboardRef.current) return;

    if (dashboardRef.current) {
        dashboardRef.current.innerHTML = "";
    }

    const loadSuperset = async () => {
      setLoading(true);
      setError(null);

      try {
        await embedDashboard({
          id: data.dashboard_id,
          // URL externa pública atualizada:
          supersetDomain: "https://vps.fmvz.usp.br/dashboard",
          mountPoint: dashboardRef.current,
          fetchGuestToken: async () => {
            const response = await fetch(`/++api++/@superset-token?dashboard_id=${data.dashboard_id}`);
            if (!response.ok) throw new Error("Erro na busca do token");
            const resData = await response.json();
            return resData.token;
          },
          dashboardConfig: {
            urlParams: {
              theme: 'light',
              standalone: 'true'
            }
          },
          dashboardUiConfig: {
            hideTitle: true,
            hideChartControls: false,
            filters: { visible: true, expanded: false },
          },
        });
        setLoading(false);
      } catch (e) {
        console.error("Erro ao embutir dashboard:", e);
        setError("Não foi possível carregar o painel. Verifique a conexão ou o ID.");
        setLoading(false);
      }
    };

    loadSuperset();

  }, [data.dashboard_id, data.align]);

  return (
    <div className={`block superset-block-view ${data.align || ''} ${data.className || ''}`} style={{ width: '100%' }}>
      {loading && (
        <div style={{ padding: '50px', textAlign: 'center', background: '#f9f9f9', border: '1px solid #eee' }}>
          <p>📊 Carregando Dashboard do Superset...</p>
        </div>
      )}

      {error && (
        <div style={{ color: '#d9534f', padding: '20px', border: '1px solid', textAlign: 'center' }}>
          {error}
        </div>
      )}

      <div
        ref={dashboardRef}
        className="superset-embed-iframe-container"
        style={{
          width: '100%',
          height: dashHeight,
          display: loading ? 'none' : 'block'
        }}
      />

<style dangerouslySetInnerHTML={{__html: `
  /* Garante que o iframe preencha o container */
  .superset-embed-iframe-container iframe {
    width: 100% !important;
    height: 100% !important;
    border: none !important;
  }

  /* QUEBRA DE CONTAINER PARA LARGURA TOTAL */
  .superset-block-view.full {
    width: 100vw !important;
    position: relative !important;
    left: 50% !important;
    right: 50% !important;
    margin-left: -50vw !important;
    margin-right: -50vw !important;
    max-width: 100vw !important;
    padding: 0 !important;
    z-index: 10;
  }

  /* Ajuste para o modo de edição do Volto não quebrar visualmente */
  .block-editor-supersetBlock {
    overflow: visible !important;
  }
`}} />
    </div>
  );
};

export default View;
